import { render, staticRenderFns } from "./FormBoxItem.vue?vue&type=template&id=35e4c8d8&scoped=true"
import script from "./FormBoxItem.vue?vue&type=script&lang=js"
export * from "./FormBoxItem.vue?vue&type=script&lang=js"
import style0 from "./FormBoxItem.vue?vue&type=style&index=0&id=35e4c8d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e4c8d8",
  null
  
)

export default component.exports